import React from 'react';
import styles from './settings.module.scss';
import testIds from '@smart-tv/e2e/shared/variables';
import { Dialog, DialogContent } from '@smart-tv/components/dialog';
import HalfCircleIcon from '@smart-tv/components/icons/half-circle';
import ImageRight from '@smart-tv/components/image/image-right';
import Typography from '@smart-tv/components/typography';
import LogoutCover from '@smart-tv/scaffold/images/boy-tablet.png';
import SettingsLogoutDialogButtons from './settings-logout-dialog-buttons';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const SettingsLogoutDialog: React.FC<Props> = (props: Props) => {
  const { open, onClose } = props;

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      dialogContainerProps={{ 'data-testid': testIds.settings.logoutDialog.dialog }}
      showCloseButton={false}
    >
      <DialogContent className={styles['dialog']}>
        <div className={styles['content']}>
          <Typography
            className={styles['title']}
            variant="h1"
            data-testid={testIds.settings.logoutDialog.header}
          >
            Log ud
          </Typography>
          <Typography
            className={styles['subtitle']}
            variant="h5"
            data-testid={testIds.settings.logoutDialog.text}
          >
            Er du sikker på, at du vil logge ud?
          </Typography>
          <SettingsLogoutDialogButtons onClose={onClose} />
          <HalfCircleIcon
            className={`${styles['half-circle-icon']} ${styles['half-circle-icon--right']}`}
            mirror={false}
          />
        </div>
        <ImageRight cover={LogoutCover}>
          <HalfCircleIcon
            className={`${styles['half-circle-icon']} ${styles['half-circle-icon--left']}`}
            mirror={true}
          />
        </ImageRight>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsLogoutDialog;
